import * as React from 'react';
import { useOffersHistoryContext } from '../../../context';

/**
 * Возвращает коллбэк, который используется для кнопки "Войдите" в компоненте AuthError.
 * Вызывает попап авторизации и по успеху загружает активный оффер
 * */
export const useHandleResolveAuthError = () => {
  const { activeOfferId, getOfferFromHistory, requestAuthentication } = useOffersHistoryContext();

  return React.useCallback(() => {
    let onSuccess;

    if (activeOfferId) {
      onSuccess = () => getOfferFromHistory({ cianId: activeOfferId });
    }

    requestAuthentication({ onSuccess });
  }, [activeOfferId, requestAuthentication, getOfferFromHistory]);
};
